import { useQuery } from "@tanstack/react-query";

import { ALL_USERS_KEY } from "@/lib/constants";
import { guacHttpClient } from "@/lib/http";
import { DashboardData, DashboardSelectedUser, HttpResponse } from "@/types";

export const dashboardDataQueryKey = (selectedUser: DashboardSelectedUser) =>
  ["dashboard", selectedUser] as const;

export function useGetDashboardData(selectedUser: DashboardSelectedUser) {
  return useQuery({
    queryKey: dashboardDataQueryKey(selectedUser),
    queryFn: async () => {
      const params = new URLSearchParams();
      if (selectedUser === ALL_USERS_KEY) {
        params.set("allUsers", "true");
      } else {
        params.set("userId", selectedUser.toString());
      }
      const path = `dashboard?${params.toString()}`;
      const res = await guacHttpClient.get<
        DashboardData,
        HttpResponse<DashboardData>
      >(path);

      return res.data;
    },
  });
}
